<template>
  <div class="plat-data-grid-site-unit"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="siteUnits">
      <template v-if="siteUnits.length">
        <keep-alive>
          <TemplateDataGrid :key="siteUnit"
                            ref="grid"
                            :gridId="gridId"
                            v-bind="gridParams"
                            v-on="$listeners">
            <template #title="{title}">
              <div class="plat-data-grid-site-unit-header">
                <span v-if="showLabel"
                      class="custom-label">教学点</span>
                <el-select v-model="siteUnit"
                           size="mini"
                           filterable>
                  <el-option v-for="siteUnit in siteUnits"
                             :key="siteUnit.code"
                             :label="siteUnit.name"
                             :value="siteUnit.code"/>
                </el-select>
                <span v-if="showTitle"
                      class="custom-title">{{title}}</span>
                <div v-if="$slots.append"
                     class="append">
                  <slot name="append"></slot>
                </div>
              </div>
            </template>
          </TemplateDataGrid>
        </keep-alive>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>教学点数据为空</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>教学点数据加载失败</div>
        <el-button type="text"
                   @click="loadSiteUnits">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/grid/wrapper'
export default {
  name: 'PlatDataGridSiteUnit',
  mixins: [Wrapper],
  components: {
    TemplateDataGrid,
    Hint
  },
  props: {
    showLabel: Boolean,
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      siteUnits: null,
      siteUnit: ''
    }
  },
  computed: {
    gridParams () {
      return {
        siteUnit: this.siteUnit
      }
    }
  },
  methods: {
    loadSiteUnits () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/siteUnits',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.siteUnits = response.data['siteUnits'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadGridData () {
      this.$nextTick(() => {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      })
    }
  },
  mounted () {
    this.loadSiteUnits()
  },
  watch: {
    siteUnits: function (val) {
      if (val && val.length) {
        let getSiteUnit
        let lastSiteUnitId = this.getWrapper('siteUnit')
        if (lastSiteUnitId) {
          getSiteUnit = val.find(siteUnit => siteUnit.code === lastSiteUnitId)
        }
        if (getSiteUnit) {
          this.siteUnit = getSiteUnit.code
        } else {
          this.siteUnit = val[0].code
        }
      }
    },
    siteUnit: function (val) {
      this.setWrapper('siteUnit', val)
    },
    gridParams: {
      handler: function () {
        this.loadGridData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .plat-data-grid-site-unit {
    height: 100%;
    .plat-data-grid-site-unit-header {
      display: inline-flex;
      align-items: center;
      .el-select {
        width: 180px;
      }
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
      .custom-title {
        margin-left: 8px;
        font-size: 13px;
      }
    }
  }
</style>
